import React, { Component } from 'react'
// import { Tabs } from 'antd';
import img1 from '../../../static/images/solution-chain-banner.jpg'
import product3 from '../../../static/images/product-3.png'

import chainSolution from '../../../static/images/chain-solution.png'
import echart1 from '../../../static/images/chain-echart-1.png'
import supermarket3 from '../../../static/images/supermarket-3.png'

import superIcon1 from '../../../static/images/supuer-icon-1.png'

import chainIcon1 from '../../../static/images/chain-icon-1.png'


import advantage1 from '../../../static/images/super-img-1.png'
import advantage2 from '../../../static/images/super-img-2.png'

import chainStore from '../../../static/images/chain-store-1.png'
import chainActive from '../../../static/images/chain-active.png'




import './index.less';
class ChainFranchise extends Component {
    state = {
        customerList: [
            { img: superIcon1, title: '促销特价/折扣' },
            { img: superIcon1, title: '单品打折' },
            { img: superIcon1, title: '类别打折' },
            { img: superIcon1, title: '全场打折' },
            { img: superIcon1, title: '供应商打折' },
            { img: superIcon1, title: '组合特价' },
            { img: superIcon1, title: '组合打折' },
            { img: superIcon1, title: '赠品促销' },
            { img: superIcon1, title: '采购促销特价' },
            { img: superIcon1, title: '超量特价' },
            { img: superIcon1, title: '超量折扣' },
            { img: superIcon1, title: '超额折扣' },
            { img: superIcon1, title: '满减' },
            { img: superIcon1, title: '满赠' },
            { img: superIcon1, title: '买M赠N' },
            { img: superIcon1, title: '更多' },
        ],
        partnerList: [
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
        ],
    }
    onEvents() { }
    render() {
        const { customerList } = this.state
        return (
            <div className="product_container unattended-container pos-container affiliate-container supermarket-container chain-container">
                <div className="top-home-carousel">
                    <div className="banner-bg"><img className="banner-img" src={img1} alt="" /></div>
                    <div className="mode-mark"></div>
                    <div className="mask-top-content">
                        <div className="content-pos">
                            <div className="content-left-text">
                                <div className="banner-top-title">悦喵AI连锁加盟方案</div>
                                <div className="banner-top-tips">专注连锁商业品牌数字化管理赋能，通过门店数字化、管理数字化、全渠道销售、全渠道会员、全渠道营销来赋能企业零售实现管理提升与营收新增长。</div>
                                <div className="banner-top-btn">了解体验</div>
                            </div>
                            
                        </div>
                        
                    </div>
                </div>


                <div className="common-block-home unattended-first">
                    <div className="common-block-home-title common-block-home-title-1">适应典型应用场景</div>
                    <div className="common-block-product">
                        <div className="store-model">
                            <img className="unattended-img-style" src={chainIcon1} alt="" />
                            <div className="store-model-title">用户获取&留存难</div>
                            <div className="store-model-tips">多种流量渠道对接繁琐，获客方式与营销渠道难对应，活动ROI难评估，定向营销难实施</div>
                        </div>
                        <div className="store-model">
                            <img className="unattended-img-style" src={chainIcon1} alt="" />
                            <div className="store-model-title">系统繁多数据割裂</div>
                            <div className="store-model-tips">会员、小程序、BI数据分析、供应链、ERP、促销物料等多套系统数据难以打通，未能形成数据闭环</div>

                        </div>
                        <div className="store-model">
                            <img className="unattended-img-style" src={chainIcon1} alt="" />
                            <div className="store-model-title">连锁门店账务繁琐</div>
                            <div className="store-model-tips">连锁加盟品牌存在各门店交易分账难、账实一致难、供应链采购支付难、加盟商费用管催难等问题，财务管理效率低</div>
                        </div>
                    </div>
                </div>

                <div className="common-block-home">
                    <div className="common-block-home-title">连锁品牌解决方案</div>
                    <div className="member-detail-service">
                        <img className="member-img-style" src={chainSolution} alt="" />
                    </div>
                </div>

                <div className="common-block-home">
                    <div className="common-block-home-title common-block-home-title-1">连锁门店灵活管理</div>
                    <div className="common-block-home-tips-1">完备的连锁管理功能，支持直播管理、加盟管理等不同管理需求，总部可实时查看所有门店经营数据，通过供应链管理体系，保障门店合理、高效运营。</div>
                    <div className="member-detail-service">
                        <img className="member-img-style member-img-style-1" src={chainStore} alt="" />
                    </div>
                </div>

                <div className="common-block-home cogradient-data-content-bg">
                    <div className="common-block-home-title"><span className="span-data">数据同步</span>线上线下数据流同步</div>
                    <div className="cogradient-data-content">
                        <div className="data-block-common">
                            <div className="data-block-common-left">
                                <img className="unattended-img-style" src={superIcon1} alt="" />
                            </div>
                            <div className="data-block-common-right">
                                <div className="data-common-title">总部统一管理商品，门店选择销售</div>
                                <div className="data-common-tips">信息同步：线下门店线上商城商品信息共享。
                                库存同步：线上线下商品库存信息同步。
                                价格同步：线上线下一套价格体系。</div>
                            </div>
                        </div>
                        <div className="data-block-common">
                            <div className="data-block-common-left">
                                <img className="unattended-img-style" src={superIcon1} alt="" />
                            </div>
                            <div className="data-block-common-right">
                                <div className="data-common-title">总部统一运营会员，门店服务好他们</div>
                                <div className="data-common-tips">权益共享：线上会员的所有权益，线下门店消费时均可享受；汇总记录：会员在线下门店的充值、消费记录线上系统均可汇总记录</div>
                            </div>
                        </div>
                        <div className="data-block-common">
                            <div className="data-block-common-left">
                                <img className="unattended-img-style" src={superIcon1} alt="" />
                            </div>
                            <div className="data-block-common-right">
                                <div className="data-common-title">总部门店库存实时共享，灵活调拨</div>
                                <div className="data-common-tips">总部和门店销售统一管理，同时出库入库也是统一管理，线上下单线下发货。总部或门店实时查看库存数据，快速调货</div>
                            </div>
                        </div>
                        <div className="data-block-common">
                            <div className="data-block-common-left">
                                <img className="unattended-img-style" src={superIcon1} alt="" />
                            </div>
                            <div className="data-block-common-right">
                                <div className="data-common-title">总部统一规划营销，门店执行活动</div>
                                <div className="data-common-tips">利用拼团、优惠券、直播等营销玩法赋能各个门店，帮助门店完成销售拓客业绩目标。线上线下营销活动可统一参加，数据同步</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="common-block-home advantage-common-block-home">
                    <div className="common-block-home-title common-block-home-title-1">营销活动一键同步所有门店</div>

                    <div className="advantage-detail">
                        <div className="advantage-detail-content">
                            
                            <div className="advantage-detail-right">
                                <img className="member-img-style" src={chainStore} alt="" />
                            </div>
                            <div className="advantage-detail-left">
                                <div className="advantage-detail-left-tips advantage-detail-left-tips-1">营销活动管理</div>
                                <div className="advantage-detail-left-title">总部做活动，分店秒同步</div>
                                <div className="advantage-detail-left-tips advantage-detail-left-tips-1">当总部发起统一的营销活动，只需在云后台设置，并同步到门店就能使用，并且一键推送到会员和客户的手机，活动业绩、利润、折让统一汇总，无需再安排人员层层通知和统计</div>
                            </div>
                        </div>

                    </div>

                    <div className="common-block-home-title common-block-home-title-1">总部品牌会员、门店共享</div>

                    <div className="advantage-detail">
                        <div className="advantage-detail-content">
                            <div className="advantage-detail-left">
                                <div className="advantage-detail-left-tips advantage-detail-left-tips-1">会员共享、储值通用</div>
                                <div className="advantage-detail-left-title">回流现金更快了</div>
                                <div className="advantage-detail-left-tips advantage-detail-left-tips-1">各门店的会员可以设置分区域共享，也可以设置全国共享，结合后台潜水会员报表，开卡门店可以根据会员消费情况发放会员优惠券进行促活，开启会员充值直达总部功能，可以让会员储值在门店间通用，月底总部对账给门店，增加会员卡价值的同时，还能为总部增加现金流。</div>
                            </div>
                            <div className="advantage-detail-right">
                                <img className="member-img-style" src={chainStore} alt="" />
                            </div>
                        </div>

                    </div>

                    <div className="common-block-home-title common-block-home-title-1">连锁订货在线订货平台</div>

                    <div className="advantage-detail">
                        <div className="advantage-detail-content">

                            <div className="advantage-detail-right">
                                <img className="member-img-style" src={chainStore} alt="" />
                            </div>
                            <div className="advantage-detail-left">
                                <div className="advantage-detail-left-tips advantage-detail-left-tips-1">货流和供应链管理</div>
                                <div className="advantage-detail-left-title">无纸化调货配货</div>
                                <div className="advantage-detail-left-tips advantage-detail-left-tips-1">餐饮版通过菜品消耗与原材料挂钩，你就能直接预知库存消耗，从而及时订货。零售版可根据库存信息实现门店间商品自由调货，全程自动化。如果你的供应商也用银豹，你就能实现一站式订货、追踪货流以及结算。</div>
                            </div>
                        </div>

                    </div>

                </div>

                <div className="common-block-home">
                    <div className="common-block-home-title" style={{ marginBottom: '20px', }}>50+种报表，500强企业也能用</div>
                    <div className="common-block-home-tips common-block-home-tips-1" style={{ fontSize: '18px',color: '#333',lineHeight: '30px',padding: '0 80px' }}>银豹云后台内置门店所需的多种营业报表，联手国际知名咨询公司A.S.Louken潜心研发，从单店到连锁都能用，帮助您分析生意、进行连锁管理，并做出科学的决策。</div>
                    <div className="common-block-product">
                        <div className="product-detail product-detail-page chain-first-page">
                            <div className="img-bg-chain">
                                <img className="product-detail-img-icon" src={echart1} alt="" />
                                <div className="product-detail-title">业绩分析</div>
                            </div>
                            
                            <div className="product-detail-tips">哪一天业绩最好？</div>
                            <div className="product-detail-tips">哪个时段销售最旺？</div>
                        </div>
                        <div className="product-detail product-detail-page chain-first-page">
                            <div className="img-bg-chain">
                                <img className="product-detail-img-icon" src={echart1} alt="" />
                                <div className="product-detail-title">占比统计</div>
                            </div>

                            <div className="product-detail-tips">哪一个产品是爆款？</div>
                            <div className="product-detail-tips">支付宝、微信哪个用得多？</div>
                        </div>
                        <div className="product-detail product-detail-page chain-first-page">
                            <div className="img-bg-chain">
                                <img className="product-detail-img-icon" src={echart1} alt="" />
                                <div className="product-detail-title">会员报表</div>
                            </div>

                            <div className="product-detail-tips">哪些会员最活跃？</div>
                            <div className="product-detail-tips">哪些会员不再来？</div>
                        </div>
                        <div className="product-detail product-detail-page chain-first-page">
                            <div className="img-bg-chain">
                                <img className="product-detail-img-icon" src={echart1} alt="" />
                                <div className="product-detail-title">折让统计</div>
                            </div>

                            <div className="product-detail-tips">双11活动效果怎么样？</div>
                            <div className="product-detail-tips">满减效果好还是打折效果好？</div>
                        </div>

                    </div>
                </div>

                <div className="common-block-home">
                    <div className="member-detail-service">
                        <img className="member-img-style" src={chainActive} alt="" />
                    </div>
                </div>



                <div className="common-block-home advantage-common-block-home background-color">
                    <div className="common-block-home-title">总部统一化管理 轻松布局千家连锁</div>
                    <div className="advantage-detail background-color">
                        <div className="advantage-detail-content">
                            <div className="advantage-detail-right">
                                <img className="member-img-style" src={advantage2} alt="" />
                            </div>
                            <div className="advantage-detail-left">
                                <div className="advantage-detail-left-tips first-style">●  支持门店多类型多元化管理</div>
                                <div className="advantage-detail-left-tips">●  供应商结算多元，灵活</div>
                                <div className="advantage-detail-left-tips">●  多种毛利计算方式，算准毛利</div>
                                <div className="advantage-btn">立即咨询</div>
                            </div>
                        </div>

                    </div>


                </div>


                
            </div >
        )
    }
}


export default ChainFranchise